import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2ec81d94&scoped=true"
var script = {}
import style0 from "./style.scss?vue&type=style&index=0&id=2ec81d94&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec81d94",
  null
  
)

export default component.exports